import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, ModalController } from '@ionic/angular';
import { SecurityService } from 'src/app/services/security.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

  img: string = '';
  interval: any;

  constructor(
    private menu: MenuController,
    private modalController: ModalController,
    private securityService: SecurityService,
    private router: Router
    // private _localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    // this.interval = setInterval(() => {
    //   let d = this._localStorageService.getRestaurantData();

    //   if (d && d.dsLogo) {
    //     this.img = d.dsLogo;
    //     clearInterval(this.interval)
    //   }
    // }, 1000)
  }

  async changePassword() {
    const modal = await this.modalController.create({
      component: ChangePasswordComponent,
      cssClass: 'password-modal',
      showBackdrop: true,
      backdropDismiss: true
    });
    return await modal.present();
  }

  logOut() {
    this.securityService.logout();
  }

  onMenuWillOpen() {
    const focusedElement = document.activeElement as HTMLElement | null;
    if (focusedElement && focusedElement instanceof HTMLElement) {
      focusedElement.blur();
    }
  }

  async goTo(page) {
    await this.menu.close();
    this.router.navigate([page]);
  }

}